import { useEffect } from "react"
import { Environment, currentEnv } from "../utils/EnvUtils"

const homeTitle = "Nexus Uploader"

const getEnvTitle = () => {
    switch (currentEnv) {
        case Environment.PROD:
            return ""
        case Environment.TEST:
            return "(TEST) "
        case Environment.DEV:
            return "(DEV) "
        case Environment.LOCAL_DEV:
            return ""
        default:
            throw new Error(`Unexpected environment when getting env title: ${currentEnv}`)
    }
}
const envTitle = getEnvTitle()
const defaultTitle = `${envTitle}${homeTitle}`

export const useTitle = (pageTitle?: string) => {
    /**
     * Update document title to pageTitle
     */
    useEffect(() => {
        document.title = pageTitle ? `${envTitle}${pageTitle} – ${homeTitle}` : defaultTitle

        return () => {
            document.title = defaultTitle
        }
    }, [pageTitle])

    return null
}
